<template>
    <div class="cust-map-container">
        <div class="map-card" :class="{ 'fullscreen-mode': isFullscreen }">
            <div class="card-header">
                <div class="chart-title">
                    <i class="el-icon-location"></i>
                    <span v-if="currentLevel === 'city'" class="breadcrumb-nav">
                        <span @click="backToProvince" class="breadcrumb-link">江西省</span>
                        <span class="breadcrumb-separator"> &gt; </span>
                        <span>{{ currentCity }}</span>
                    </span>
                    <span v-else>江西省</span>
                    <i 
                        :class="isFullscreen ? 'el-icon-close' : 'el-icon-full-screen'"
                        @click="toggleFullscreen"
                        class="fullscreen-btn-icon ml-auto"
                    ></i>
                </div>
            </div>
            
            <div id="map-container" class="map-container" :class="{ 'has-detail-panel': selectedCustomer }">

                
                
            </div>

            <div class="city-stats-panel" v-if="currentLevel === 'province'">
                    <div class="city-stats-panel-header">各地市客户数量</div>
                    <div class="city-stats-panel-list">
                        <div 
                            v-for="city in cityStatsList.filter(c => c.count > 0)" 
                            :key="city.name" 
                            class="city-stats-panel-item has-count"
                        >
                            <span class="city-dot" :style="{ backgroundColor: '#1890ff' }"></span>
                            <span class="city-overlay-name">{{ city.name }}</span>
                            <span class="city-overlay-count" :style="{ color: '#1890ff' }">{{ city.count }}</span>
                        </div>
                    </div>
                </div>
                
            
            <div class="customer-list-panel" v-if="currentLevel === 'city' && cityCustomersCache[currentCity]">
                    <div class="customer-list-header">
                        <span>{{ currentCity }}客户列表</span>
                        <span class="customer-count">{{ cityCustomersCache[currentCity]?.length || 0 }}</span>
                    </div>
                    <div class="customer-list-search">
                        <el-input
                            v-model="customerSearchKeyword"
                            placeholder="搜索客户"
                            size="mini"
                            prefix-icon="el-icon-search"
                            clearable
                        ></el-input>
                    </div>
                    <div class="customer-list-body">
                        <div 
                            v-for="customer in filteredCustomerList" 
                            :key="customer.id || customer.custNo"
                            class="customer-list-item"
                            :class="{ 'active': selectedCustomer && selectedCustomer.id === customer.id }"
                            @click="showCustomerInfo(customer)"
                        >
                            <div class="customer-item-name">{{ customer.custName || customer.customer_name }}</div>
                            <div class="customer-item-info">
                                <span class="customer-item-category">
                                    <el-tag 
                                        size="mini" 
                                        :style="{
                                            backgroundColor: getIndustryTagColor(customer.industryName || customer.customer_category),
                                            borderColor: getIndustryBorderColor(customer.industryName || customer.customer_category),
                                            color: getIndustryTextColor(customer.industryName || customer.customer_category)
                                        }"
                                        effect="light"
                                        class="customer-tag"
                                    >
                                        {{ customer.industryName || customer.customer_category }}
                                    </el-tag>
                                </span>
                            </div>
                        </div>
                        <div v-if="!filteredCustomerList || filteredCustomerList.length === 0" class="customer-list-empty">
                            暂无客户数据
                        </div>
                    </div>
                </div>

            <div id="loading-overlay" :class="{ 'hidden': !isMapLoading }">
                <div class="spinner"></div>
                <p class="loading-text">正在加载地图...</p>
            </div>

            <transition name="slide-right">
                <div v-if="selectedCustomer" class="customer-detail-panel" :class="{ 'fullscreen-panel': isFullscreen }">
                    <div class="panel-header">
                        <h3>{{ selectedCustomer.custName || selectedCustomer.customer_name }}</h3>
                        <i class="el-icon-close close-btn" @click="closeMarkerModal"></i>
                    </div>
                    <div class="panel-body">
                        <div class="detail-tag">
                            <el-tag :class="'industry-tag-' + getIndustryClass(selectedCustomer.industry || selectedCustomer.customer_category)">
                                {{ selectedCustomer.industryName || selectedCustomer.customer_category }}
                            </el-tag>
                        </div>
                        
                        <el-divider></el-divider>
                        
                        <el-descriptions :column="1" size="medium" border>
                            <el-descriptions-item label="客户编号">
                                {{ selectedCustomer.custNo || '暂无' }}
                            </el-descriptions-item>
                            
                            <el-descriptions-item label="所在城市">
                                {{ selectedCustomer.cityName || selectedCustomer.city || '暂无' }}
                            </el-descriptions-item>
                            
                            <el-descriptions-item label="省份">
                                {{ selectedCustomer.provinceName || selectedCustomer.province || '暂无' }}
                            </el-descriptions-item>
                            
                            <el-descriptions-item label="详细地址">
                                {{ selectedCustomer.address || selectedCustomer.customer_address || '暂无' }}
                            </el-descriptions-item>
                            
                            <el-descriptions-item label="经度">
                                {{ selectedCustomer.longitude || '暂无' }}
                            </el-descriptions-item>
                            
                            <el-descriptions-item label="纬度">
                                {{ selectedCustomer.latitude || '暂无' }}
                            </el-descriptions-item>
                            
                            <el-descriptions-item label="联系电话" v-if="selectedCustomer.phone">
                                <a :href="'tel:' + selectedCustomer.phone">{{ selectedCustomer.phone }}</a>
                            </el-descriptions-item>
                            
                            <el-descriptions-item label="创建时间">
                                {{ formatDateTime(selectedCustomer.createTime || selectedCustomer.create_time) }}
                            </el-descriptions-item>
                            
                            <el-descriptions-item label="备注">
                                {{ selectedCustomer.remarks || selectedCustomer.remark || '暂无' }}
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>
                </div>
            </transition>
        </div>

        <el-dialog
            title="未分配客户列表"
            :visible.sync="showModal"
            width="1200px"
        >
            <el-table
                :data="unallocatedCustomers"
                :pagination="false"
                row-key="id"
                size="medium"
            >
                <el-table-column prop="id" label="ID" width="80"></el-table-column>
                <el-table-column prop="customer_name" label="客户名称"></el-table-column>
                <el-table-column prop="customer_category" label="客户分类"></el-table-column>
                <el-table-column prop="create_time" label="创建时间" width="180" class-name="cell-two-line">
                    <template slot-scope="scope">
                        {{ formatDateTime(scope.row.create_time) }}
                    </template>
                </el-table-column>
                <el-table-column prop="customer_address" label="客户地址"></el-table-column>
                <el-table-column label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button type="primary" size="small" @click="goToAllocate(scope.row)">
                            去分配
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
import * as echarts from 'echarts'
import { Message } from 'element-ui'
import { countByCity, listCustWithLocation } from '../../api/cust/index'

const cityNames = ['南昌市', '景德镇市', '萍乡市', '九江市', '新余市', '鹰潭市', '赣州市', '吉安市', '宜春市', '抚州市', '上饶市']

const CustomerData = {
    cities: {
        '南昌市': [],
        '景德镇市': [],
        '萍乡市': [],
        '九江市': [],
        '新余市': [],
        '鹰潭市': [],
        '赣州市': [],
        '吉安市': [],
        '宜春市': [],
        '抚州市': [],
        '上饶市': []
    },
    getCityCenters() {
        return {
            '南昌市': [115.8921, 28.6877],
            '景德镇市': [117.1784, 29.2687],
            '萍乡市': [113.8545, 27.6228],
            '九江市': [115.9676, 29.7057],
            '新余市': [114.9171, 27.8179],
            '鹰潭市': [117.0694, 28.2607],
            '赣州市': [114.9355, 25.8453],
            '吉安市': [114.9793, 27.1095],
            '宜春市': [114.4156, 27.8134],
            '抚州市': [116.3584, 27.9492],
            '上饶市': [117.9435, 28.4557]
        }
    },
    generateCustomers(cityName, count) {
        const industries = ['金融', '政府', '教育', '医疗', '企业']
        const types = ['VIP客户', '普通客户', '潜在客户']
        const customers = []
        const centers = this.getCityCenters()
        const center = centers[cityName] || [115.9, 27.6]
        
        for (let i = 0; i < count; i++) {
            customers.push({
                name: `${cityName.slice(0, -1)}客户${i + 1}`,
                company: `${cityName.slice(0, -1)}科技有限公司`,
                industry: industries[Math.floor(Math.random() * industries.length)],
                type: types[Math.floor(Math.random() * types.length)],
                address: `${cityName}某街道${Math.floor(Math.random() * 100 + 1)}号`,
                lng: center[0] + (Math.random() - 0.5) * 0.5,
                lat: center[1] + (Math.random() - 0.5) * 0.5
            })
        }
        return customers
    },
    generateAllCustomers(total) {
        const cities = Object.keys(this.cities)
        const customers = []
        
        cities.forEach((city, index) => {
            const count = index < total % cities.length ? Math.floor(total / cities.length) + 1 : Math.floor(total / cities.length)
            const cityCustomers = this.generateCustomers(city, Math.max(count, 1))
            this.cities[city] = cityCustomers
            customers.push(...cityCustomers)
        })
        
        return customers
    },
    getCustomerCountByCity(city) {
        return this.cities[city]?.length || 0
    },
    getAllCustomersByCity(city) {
        return this.cities[city] || []
    }
}

export default {
    name: 'CustMap',
    data() {
        return {
            stats: {
                totalCustomers: 15,
                allocatedCustomers: 10,
                unallocatedCustomers: 5,
                todayNewCustomers: 3
            },
            unallocatedCustomers: [
                { id: 1, customer_name: '江西省公积金管理中心', customer_category: '政府', create_time: '2025-05-01 10:30:00' },
                { id: 2, customer_name: '南昌市人力资源和社会保障局', customer_category: '政府', create_time: '2025-05-01 11:15:00' },
                { id: 3, customer_name: '天虹商场(八一广场店)', customer_category: '其他', create_time: '2025-05-01 14:20:00' }
            ],
            showModal: false,
            customerMarkers: [],
            selectedCustomer: null,
            showMarkerModal: false,
            customerStats: {},
            cityCenters: {},
            isFullscreen: false,
            isMapLoading: true,
            realCustomers: [],
            chart: null,
            currentLevel: 'province',
            currentCity: null,
            provinceData: null,
            cityDataCache: {},
            cityCenterCache: {},
            cityNames: cityNames,
            CustomerData: CustomerData,
            cityCustomerCountMap: {},
            cityCustomersCache: {},
            customerSearchKeyword: '',
            mapTheme: 'default',
            showAllMarkers: false,
            isCustomerMarkersVisible: false,
            isSelectingLocation: false,
            selectedLocation: null,
            locationSuggestions: [],
            locationSearchKeyword: '',
            locationClickTimeout: null
        }
    },
    computed: {
        cityStatsList() {
            const defaultCounts = {
                '南昌市': 0,
                '景德镇市': 0,
                '萍乡市': 0,
                '九江市': 0,
                '新余市': 0,
                '鹰潭市': 0,
                '赣州市': 0,
                '吉安市': 0,
                '宜春市': 0,
                '抚州市': 0,
                '上饶市': 0
            }
            
            Object.keys(this.cityCustomerCountMap).forEach(key => {
                let normalizedKey = key
                if (!key.endsWith('市')) {
                    normalizedKey = key + '市'
                }
                defaultCounts[normalizedKey] = this.cityCustomerCountMap[key]
            })
            
            return this.cityNames.map(cityName => {
                const count = defaultCounts[cityName] || 0
                let color = '#f0f0f0'
                if (count > 30) {
                    color = '#40a9ff'
                } else if (count > 10) {
                    color = '#1890ff'
                } else if (count > 0) {
                    color = '#69c0ff'
                }
                return {
                    name: cityName.replace('市', ''),
                    count: count,
                    color: color
                }
            })
        },
        maxCustomerCount() {
            const counts = Object.values(this.cityCustomerCountMap)
            return counts.length > 0 ? Math.max(...counts) : 0
        },
        currentCustomers() {
            if (this.currentLevel === 'city' && this.currentCity) {
                return this.cityCustomersCache[this.currentCity] || []
            }
            return this.realCustomers
        },
        filteredCustomerList() {
            const customers = this.currentCustomers
            if (!this.customerSearchKeyword) {
                return customers
            }
            const keyword = this.customerSearchKeyword.toLowerCase()
            return customers.filter(c => {
                const name = (c.custName || c.customer_name || '').toLowerCase()
                const city = (c.cityName || c.city || '').toLowerCase()
                return name.includes(keyword) || city.includes(keyword)
            })
        }
    },
    created() {
        this.loadDashboardStats()
        this.loadUnallocatedCustomers()
        this.loadRealCustomers()
        this.loadCityCustomerCount()
    },
    mounted() {
        document.addEventListener('fullscreenchange', this.handleFullscreenChange)
        document.addEventListener('webkitfullscreenchange', this.handleFullscreenChange)
        this.initChart()
        this.initCustomerData()
        this.loadProvinceMap()
        this.setupEventListeners()
    },
    beforeDestroy() {
        document.removeEventListener('fullscreenchange', this.handleFullscreenChange)
        document.removeEventListener('webkitfullscreenchange', this.handleFullscreenChange)
        if (this.chart) {
            this.chart.dispose()
        }
    },
    methods: {
        formatDateTime(dateStr) {
            if (!dateStr) return ''
            try {
                const trimmed = dateStr.trim()
                const date = new Date(trimmed)
                if (isNaN(date.getTime())) {
                    const match = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/)
                    if (match) {
                        return `${match[1]}-${match[2]}-${match[3]} ${match[4]}:${match[5]}:${match[6]}`
                    }
                    return trimmed
                }
                const year = date.getFullYear()
                const month = String(date.getMonth() + 1).padStart(2, '0')
                const day = String(date.getDate()).padStart(2, '0')
                const hours = String(date.getHours()).padStart(2, '0')
                const minutes = String(date.getMinutes()).padStart(2, '0')
                const seconds = String(date.getSeconds()).padStart(2, '0')
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
            } catch {
                return dateStr
            }
        },
        loadDashboardStats() {
            // this.postRequest('/dashboard/stats').then((response) => {
            //     if (response && response.result) {
            //         Object.assign(this.stats, response.result)
            //     }
            // }).catch((error) => {
            //     console.error('Failed to load dashboard stats:', error)
            // })
        },
        loadUnallocatedCustomers() {
            // this.postRequest('/cust/unallocated').then((response) => {
            //     if (response && response.result) {
            //         this.unallocatedCustomers = response.result
            //     }
            // }).catch((error) => {
            //     console.error('Failed to load unallocated customers:', error)
            // })
        },
        goToAllocate(customer) {
            this.$router.push({ path: '/allocations/new', query: { customerId: customer.id } })
        },
        goToEditCustomer(customer) {
            this.closeMarkerModal()
            this.$router.push(`/customers/${customer.id}/edit`)
        },
        goToAllocateCustomer(customer) {
            this.closeMarkerModal()
            this.$router.push({ path: '/allocations/new', query: { customerId: customer.id } })
        },
        async loadCityCustomerCount() {
            try {
                const resp = await countByCity('江西省')
                if (resp && resp.code === 200 && resp.data) {
                    this.cityCustomerCountMap = {}
                    resp.data.forEach(item => {
                        this.cityCustomerCountMap[item.cityName] = item.custCount || 0
                    })
                    console.log('📊 各城市客户数量统计:', this.cityCustomerCountMap)
                    // 确保图表已初始化、地图已注册、且当前是省级视图才更新
                    if (this.chart && this.provinceData && this.currentLevel === 'province') {
                        this.$nextTick(() => {
                            if (this.chart && !this.chart.isDisposed()) {
                                this.chart.setOption(this.createProvinceOption(), true)
                            }
                        })
                    }
                }
            } catch (error) {
                console.error('加载城市客户数量失败:', error)
            }
        },
        async loadCityCustomers(cityName) {
            if (this.cityCustomersCache[cityName]) {
                return this.cityCustomersCache[cityName]
            }
            try {
                const resp = await listCustWithLocation({ cityName, page: 1, limit: 999999 })
                if (resp && resp.code === 200 && resp.data) {
                    this.cityCustomersCache[cityName] = resp.data
                    console.log(`📍 ${cityName} 客户数据加载完成: ${resp.data.length} 个`)
                    return resp.data
                }
                if (resp && resp.code === 200 && Array.isArray(resp)) {
                    this.cityCustomersCache[cityName] = resp
                    console.log(`📍 ${cityName} 客户数据加载完成: ${resp.length} 个`)
                    return resp
                }
                const mockCustomers = this.generateMockCustomers(cityName)
                this.cityCustomersCache[cityName] = mockCustomers
                console.log(`📍 ${cityName} 使用模拟数据: ${mockCustomers.length} 个`)
                return mockCustomers
            } catch (error) {
                console.warn(`加载${cityName}客户失败，使用模拟数据:`, error)
                const mockCustomers = this.generateMockCustomers(cityName)
                this.cityCustomersCache[cityName] = mockCustomers
                return mockCustomers
            }
        },
        generateMockCustomers(cityName) {
            const industries = ['政府', '教育', '企业', '金融', '医疗']
            const centers = this.CustomerData.getCityCenters()
            const center = centers[cityName] || [115.9, 27.6]
            const customers = []
            for (let i = 0; i < 5; i++) {
                customers.push({
                    id: cityName + i,
                    custNo: 'CUST' + cityName.replace('市', '') + String(i + 1).padStart(3, '0'),
                    custName: `${cityName.replace('市', '')}客户${i + 1}`,
                    customer_name: `${cityName.replace('市', '')}客户${i + 1}`,
                    cityName: cityName,
                    city: cityName,
                    industryName: industries[i % industries.length],
                    customer_category: industries[i % industries.length],
                    longitude: center[0] + (Math.random() - 0.5) * 0.2,
                    latitude: center[1] + (Math.random() - 0.5) * 0.2,
                    address: `${cityName}某街道${Math.floor(Math.random() * 100 + 1)}号`,
                    customer_address: `${cityName}某街道${Math.floor(Math.random() * 100 + 1)}号`
                })
            }
            return customers
        },
        loadRealCustomers() {
            // this.postRequest('/cust/list', { page: 1, limit: 1000 }).then((response) => {
            //     if (response && response.result && response.result.list) {
            //         this.realCustomers = response.result.list.filter(c => c.longitude && c.latitude)
            //         console.log('✅ 已加载真实客户数据:', this.realCustomers.length)
            //     }
            // }).catch((error) => {
            //     console.error('❌ 加载客户数据失败:', error)
            // })
        },
        getCustomerMarkers(cityName = null) {
            let customers = this.realCustomers
            
            if (cityName) {
                const cityMap = {
                    '南昌市': ['南昌', 'Nanchang'],
                    '景德镇市': ['景德镇', 'Jingdezhen'],
                    '萍乡市': ['萍乡', 'Pingxiang'],
                    '九江市': ['九江', 'Jiujiang'],
                    '新余市': ['新余', 'Xinyu'],
                    '鹰潭市': ['鹰潭', 'Yingtan'],
                    '赣州市': ['赣州', 'Ganzhou'],
                    '吉安市': ['吉安', 'Jian'],
                    '宜春市': ['宜春', 'Yichun'],
                    '抚州市': ['抚州', 'Fuzhou'],
                    '上饶市': ['上饶', 'Shangrao']
                }
                const keywords = cityMap[cityName] || [cityName.replace('市', '')]
                
                customers = this.realCustomers.filter(c => {
                    const customerCity = c.city || ''
                    const address = c.customer_address || ''
                    
                    const matchByCityField = keywords.some(k => 
                        customerCity.includes(k) || customerCity.includes(k.replace('市', ''))
                    )
                    
                    if (matchByCityField) {
                        return true
                    }
                    
                    const addressLower = address.toLowerCase()
                    const matchByAddress = keywords.some(k => 
                        addressLower.includes(k.toLowerCase())
                    )
                    
                    return matchByAddress
                })
            }
            
            return customers.map(customer => ({
                name: customer.custName || customer.customer_name || '未知',
                value: [customer.longitude, customer.latitude],
                customer: customer
            }))
        },
        getCategoryType(category) {
            const types = {
                '政府': '',
                '教育': 'success',
                '企业': 'warning',
                '央国企': 'purple',
                '金融': 'danger',
                '医疗': 'info',
                '其他': 'warning'
            }
            return types[category] || 'warning'
        },
        getIndustryType(industry) {
            const types = {
                '政府': '',
                '教育': 'success',
                '企业': 'warning',
                '央国企': 'purple',
                '金融': 'danger',
                '医疗': 'info',
                '个人': 'info',
                '合作商': 'warning',
                '其他': 'warning'
            }
            const industryMap = { 1: '政府', 2: '企业', 3: '教育', 4: '医疗', 5: '金融', 6: '个人', 7: '合作商', 8: '其他' }
            const name = typeof industry === 'number' ? (industryMap[industry] || industry) : industry
            return types[name] || 'warning'
        },
        getIndustryClass(industry) {
            const industryMap = { 1: '政府', 2: '企业', 3: '教育', 4: '医疗', 5: '金融', 6: '个人', 7: '合作商', 8: '其他' }
            const name = typeof industry === 'number' ? (industryMap[industry] || industry) : industry
            const classMap = {
                '政府': 'gov',
                '企业': 'enterprise',
                '教育': 'education',
                '金融': 'finance',
                '医疗': 'medical',
                '央国企': 'state',
                '个人': 'personal',
                '合作商': 'partner',
                '其他': 'other'
            }
            return classMap[name] || 'other'
        },
        showCustomerInfo(customer) {
            this.selectedCustomer = customer
            this.addCustomerMarker(customer)
        },
        selectCustomerFromList(customer) {
            this.selectedCustomer = customer
            
            const lng = customer.longitude || customer.lng
            const lat = customer.latitude || customer.lat
            
            if (lng && lat && !isNaN(lng) && !isNaN(lat)) {
                this.chart.setOption({
                    geo: {
                        center: [lng, lat],
                        zoom: 3
                    }
                })
            }
            
            const option = this.createCityOption(this.currentCity, this.cityCenterCache[this.currentCity], [customer], customer)
            this.chart.setOption(option, true)
        },
        addCustomerMarker(customer) {
            if (!customer || !this.chart) return
            
            const lng = customer.longitude || customer.lng
            const lat = customer.latitude || customer.lat
            
            if (!lng || !lat || isNaN(lng) || isNaN(lat)) {
                console.warn('客户缺少经纬度信息:', customer.custName || customer.customer_name)
                return
            }
            
            const industry = customer.industryName || customer.customer_category || customer.industry
            const industryColor = this.getIndustryColor(industry)
            const customerName = customer.custName || customer.customer_name || '未知'
            const isTech = this.mapTheme === 'tech'
            
            this.chart.setOption({
                series: [{
                    name: 'selected-customer',
                    type: 'effectScatter',
                    coordinateSystem: 'geo',
                    data: [{
                        name: customerName,
                        value: [lng, lat],
                        customer: customer,
                        itemStyle: {
                            color: industryColor
                        }
                    }],
                    symbolSize: isTech ? 16 : 14,
                    showEffectOn: 'render',
                    rippleEffect: {
                        brushType: 'stroke',
                        scale: isTech ? 5 : 4,
                        period: isTech ? 2 : 3
                    },
                    zlevel: 1000,
                    itemStyle: {
                        color: industryColor,
                        shadowBlur: isTech ? 15 : 10,
                        shadowColor: industryColor
                    },
                    label: {
                        show: true,
                        position: 'top',
                        distance: 8,
                        formatter: '{b}',
                        fontSize: isTech ? 11 : 12,
                        color: isTech ? '#00ff88' : '#1a365d',
                        backgroundColor: isTech ? 'rgba(10, 25, 41, 0.9)' : 'rgba(255, 255, 255, 0.9)',
                        borderColor: isTech ? '#00d4ff' : '#1890ff',
                        borderWidth: 1,
                        borderRadius: 4,
                        padding: [4, 8]
                    }
                }]
            })
            
            this.chart.setOption({
                geo: {
                    center: [lng, lat],
                    zoom: isTech ? 2.5 : 3
                }
            })
        },
        getIndustryColor(industry) {
            const industryMap = { 1: '政府', 2: '企业', 3: '教育', 4: '医疗', 5: '金融', 6: '个人', 7: '合作商', 8: '其他' }
            const name = typeof industry === 'number' ? (industryMap[industry] || industry) : industry
            const colorMap = {
                '政府': '#1890ff',
                '企业': '#faad14',
                '教育': '#52c41a',
                '金融': '#eb2f96',
                '医疗': '#13c2c2',
                '个人': '#722ed1',
                '合作商': '#fa8c16',
                '其他': '#8c8c8c'
            }
            return colorMap[name] || '#1890ff'
        },
        getIndustryTagColor(industry) {
            const industryMap = { 1: '政府', 2: '企业', 3: '教育', 4: '医疗', 5: '金融', 6: '个人', 7: '合作商', 8: '其他' }
            const name = typeof industry === 'number' ? (industryMap[industry] || industry) : industry
            const colorMap = {
                '政府': '#e6f7ff',
                '企业': '#fff7e6',
                '教育': '#f6ffed',
                '金融': '#fff0f6',
                '医疗': '#e6fffb',
                '个人': '#f9f0ff',
                '合作商': '#fff7e6',
                '其他': '#f7f7f7'
            }
            return colorMap[name] || '#e6f7ff'
        },
        getIndustryBorderColor(industry) {
            const industryMap = { 1: '政府', 2: '企业', 3: '教育', 4: '医疗', 5: '金融', 6: '个人', 7: '合作商', 8: '其他' }
            const name = typeof industry === 'number' ? (industryMap[industry] || industry) : industry
            const colorMap = {
                '政府': '#1890ff',
                '企业': '#faad14',
                '教育': '#52c41a',
                '金融': '#eb2f96',
                '医疗': '#13c2c2',
                '个人': '#722ed1',
                '合作商': '#fa8c16',
                '其他': '#8c8c8c'
            }
            return colorMap[name] || '#1890ff'
        },
        getIndustryTextColor(industry) {
            const industryMap = { 1: '政府', 2: '企业', 3: '教育', 4: '医疗', 5: '金融', 6: '个人', 7: '合作商', 8: '其他' }
            const name = typeof industry === 'number' ? (industryMap[industry] || industry) : industry
            const colorMap = {
                '政府': '#1890ff',
                '企业': '#d97706',
                '教育': '#389e0d',
                '金融': '#c41e7e',
                '医疗': '#08979c',
                '个人': '#531dab',
                '合作商': '#d97706',
                '其他': '#666'
            }
            return colorMap[name] || '#1890ff'
        },
        closeMarkerModal() {
            this.selectedCustomer = null
        },
        async toggleFullscreen() {
            const cardElement = document.querySelector('.map-card')
            
            if (!document.fullscreenElement && !document.webkitFullscreenElement) {
                try {
                    if (cardElement.requestFullscreen) {
                        await cardElement.requestFullscreen()
                    } else if (cardElement.webkitRequestFullscreen) {
                        await cardElement.webkitRequestFullscreen()
                    }
                    this.isFullscreen = true
                    setTimeout(() => {
                        if (this.chart) this.chart.resize()
                    }, 200)
                } catch (error) {
                    console.error('进入全屏失败:', error)
                }
            } else {
                try {
                    if (document.exitFullscreen) {
                        await document.exitFullscreen()
                    } else if (document.webkitExitFullscreen) {
                        await document.webkitExitFullscreen()
                    }
                    this.isFullscreen = false
                    setTimeout(() => {
                        if (this.chart) this.chart.resize()
                    }, 200)
                } catch (error) {
                    console.error('退出全屏失败:', error)
                }
            }
        },
        handleFullscreenChange() {
            const isInFullscreen = !!(document.fullscreenElement || document.webkitFullscreenElement)
            this.isFullscreen = isInFullscreen
            if (this.chart) {
                setTimeout(() => {
                    this.chart.resize()
                }, 200)
            }
        },
        mockCityGeoData(cityName) {
            const centers = this.CustomerData.getCityCenters()
            const center = centers[cityName] || [115.9, 27.6]
            
            const radius = 0.5
            const points = []
            for (let i = 0; i < 36; i++) {
                const angle = (i / 36) * Math.PI * 2
                points.push([
                    center[0] + Math.cos(angle) * radius,
                    center[1] + Math.sin(angle) * radius
                ])
            }
            
            return {
                type: 'FeatureCollection',
                features: [{
                    type: 'Feature',
                    properties: { name: cityName, center: center },
                    geometry: {
                        type: 'Polygon',
                        coordinates: [points]
                    }
                }]
            }
        },
        getProvinceMapURL() {
            // 使用本地 GeoJSON 文件
            return '/geojson/360000_full.json'
        },
        getCityMapURL(cityName) {
            const cityCodes = {
                '南昌市': '360100',
                '景德镇市': '360200',
                '萍乡市': '360300',
                '九江市': '360400',
                '新余市': '360500',
                '鹰潭市': '360600',
                '赣州市': '360700',
                '吉安市': '360800',
                '宜春市': '360900',
                '抚州市': '361000',
                '上饶市': '361100'
            }
            const code = cityCodes[cityName]
            // 使用本地 GeoJSON 文件
            return code ? `/geojson/${code}_full.json` : null
        },
        getBackupCityMapURLs(cityName) {
            const cityCodes = {
                '南昌市': '360100',
                '景德镇市': '360200',
                '萍乡市': '360300',
                '九江市': '360400',
                '新余市': '360500',
                '鹰潭市': '360600',
                '赣州市': '360700',
                '吉安市': '360800',
                '宜春市': '360900',
                '抚州市': '361000',
                '上饶市': '361100'
            }
            const code = cityCodes[cityName]
            if (!code) return []
            
            return []
        },
        async loadProvinceData() {
            try {
                const response = await fetch(this.getProvinceMapURL())
                const data = await response.json()
                if (data && data.features && data.features.length > 0) {
                    return data
                }
                console.warn('在线地图数据无效，尝试使用本地文件')
                const localResponse = await fetch('/jx.geojson')
                return await localResponse.json()
            } catch (error) {
                console.error('加载省级地图失败:', error)
                try {
                    console.warn('尝试使用本地文件')
                    const localResponse = await fetch('/jx.geojson')
                    return await localResponse.json()
                } catch (localError) {
                    console.error('加载本地地图失败:', localError)
                    return null
                }
            }
        },
        async loadCityData(cityName) {
            const url = this.getCityMapURL(cityName)
            const backupUrls = this.getBackupCityMapURLs(cityName)
            const allUrls = [url, ...backupUrls]
            
            for (let i = 0; i < allUrls.length; i++) {
                const currentUrl = allUrls[i]
                if (!currentUrl) continue
                
                try {
                    console.log(`尝试加载${cityName}地图: ${currentUrl}`)
                    const response = await fetch(currentUrl)
                    
                    if (!response.ok) {
                        console.warn(`[${i + 1}/${allUrls.length}] 获取地图数据失败 (${response.status}): ${currentUrl}`)
                        continue
                    }
                    
                    const data = await response.json()
                    if (data && data.features && data.features.length > 0) {
                        console.log(`✅ ${cityName}地图加载成功 (来源: ${currentUrl})`)
                        return data
                    }
                    
                    console.warn(`[${i + 1}/${allUrls.length}] 地图数据为空: ${currentUrl}`)
                } catch (error) {
                    console.warn(`[${i + 1}/${allUrls.length}] 加载失败: ${currentUrl}`, error.message)
                }
            }
            
            console.error(`❌ 所有地图数据源都加载失败: ${cityName}`)
            return null
        },
        getCityCode(cityName) {
            const cityCodes = {
                '南昌市': '360100',
                '景德镇市': '360200',
                '萍乡市': '360300',
                '九江市': '360400',
                '新余市': '360500',
                '鹰潭市': '360600',
                '赣州市': '360700',
                '吉安市': '360800',
                '宜春市': '360900',
                '抚州市': '361000',
                '上饶市': '361100'
            }
            return cityCodes[cityName] || ''
        },
        initChart() {
            const container = document.getElementById('map-container')
            if (!container) {
                console.error('map-container 元素未找到')
                return
            }
            
            const tryInit = (attempts = 0) => {
                const rect = container.getBoundingClientRect()
                if (rect.height > 0) {
                    this.chart = echarts.init(container)
                    setTimeout(() => {
                        if (this.chart) this.chart.resize()
                    }, 100)
                } else if (attempts < 10) {
                    setTimeout(() => tryInit(attempts + 1), 100)
                } else {
                    this.chart = echarts.init(container)
                    setTimeout(() => {
                        if (this.chart) this.chart.resize()
                    }, 200)
                }
            }
            
            tryInit()
            
            window.addEventListener('resize', () => {
                this.chart && this.chart.resize()
            })
        },
        initCustomerData() {
            const customers = this.CustomerData.generateAllCustomers(15)
            console.log('已生成', customers.length, '个客户数据')
        },
        getCustomerCountByCityName(cityName) {
            if (this.cityCustomerCountMap[cityName] !== undefined) {
                return this.cityCustomerCountMap[cityName]
            }
            const cityMap = {
                '南昌市': ['南昌', 'Nanchang'],
                '景德镇市': ['景德镇', 'Jingdezhen'],
                '萍乡市': ['萍乡', 'Pingxiang'],
                '九江市': ['九江', 'Jiujiang'],
                '新余市': ['新余', 'Xinyu'],
                '鹰潭市': ['鹰潭', 'Yingtan'],
                '赣州市': ['赣州', 'Ganzhou'],
                '吉安市': ['吉安', 'Jian'],
                '宜春市': ['宜春', 'Yichun'],
                '抚州市': ['抚州', 'Fuzhou'],
                '上饶市': ['上饶', 'Shangrao']
            }
            
            const keywords = cityMap[cityName] || [cityName.replace('市', '')]
            
            const count = this.realCustomers.filter(customer => {
                const customerCity = customer.city || ''
                const address = customer.customer_address || ''
                
                const matchByCityField = keywords.some(k => 
                    customerCity.includes(k) || customerCity.includes(k.replace('市', ''))
                )
                
                if (matchByCityField) {
                    return true
                }
                
                const addressLower = address.toLowerCase()
                const matchByAddress = keywords.some(k => 
                    addressLower.includes(k.toLowerCase())
                )
                
                return matchByAddress
            }).length
            
            return count
        },
        getCustomerColor(count, maxCount) {
            if (count === 0) return '#f0f0f0'
            if (count > 30) return '#40a9ff'
            if (count > 10) return '#1890ff'
            return '#69c0ff'
        },
        getCityCenter(cityName) {
            return this.CustomerData.getCityCenters()[cityName] || [115.9, 27.6]
        },
        createProvinceOption() {
            const cities = Object.keys(this.CustomerData.cities)
            
            const cityCounts = cities.map(city => ({
                name: city,
                count: this.getCustomerCountByCityName(city)
            }))

            const maxCount = Math.max(...cityCounts.map(c => c.count), 1)
            
            const data = cityCounts.map(city => ({
                name: city.name,
                value: city.count
            }))
            
            const cityColorMap = {}
            cities.forEach(city => {
                const count = this.getCustomerCountByCityName(city)
                cityColorMap[city] = this.getCustomerColor(count, maxCount)
            })
            
            const isTech = this.mapTheme === 'tech'
            
            return {
                backgroundColor: isTech ? '#0a1929' : '#ffffff',
                visualMap: {
                    show: true,
                    min: 0,
                    max: maxCount,
                    right: 24,
                    bottom: 24,
                    orient: 'horizontal',
                    text: ['多', '少'],
                    textStyle: {
                        color: '#666',
                        fontSize: 12
                    },
                    inRange: {
                        color: ['#f0f0f0', '#69c0ff', '#1890ff', '#40a9ff']
                    },
                    itemWidth: 15,
                    itemHeight: 120,
                    itemGap: 8,
                    borderColor: '#e8e8e8',
                    borderWidth: 1
                },
                geo: {
                        map: 'jiangxi',
                        roam: true,
                        zoom: 1.2,
                        center: [115.9, 27.6],
                        scaleLimit: {
                            min: 0.8,
                            max: 3
                        },
                        itemStyle: {
                            areaColor: '#e8f4fc',
                            borderColor: '#1890ff',
                            borderWidth: 1.5
                        },
                        emphasis: {
                            itemStyle: {
                                areaColor: '#e8f4fc',
                                borderColor: '#5ba3d9'
                            },
                            label: {
                                color: '#1a365d',
                                fontWeight: 'bold',
                                fontSize: 18,
                            }
                        },
                        label: {
                        show: true,
                        color: '#333',
                        fontSize: 16,
                        fontWeight: 'normal'
                    }
                },
                series: [{
                    type: 'map',
                    map: 'jiangxi',
                    geoIndex: 0,
                    aspectScale: 0.75,
                    showLegendSymbol: false,
                    data: data,
                    itemStyle: {
                        areaColor: (params) => {
                            const cityName = params.name || params.data?.name || ''
                            return cityColorMap[cityName] || '#f0f0f0'
                        },
                        borderColor: '#91d5ff',
                        borderWidth: 1
                    },
                    emphasis: {
                        itemStyle: {
                            areaColor: (params) => {
                                const cityName = params.name || params.data?.name || ''
                                const count = this.getCustomerCountByCityName(cityName)
                                if (count > 0) {
                                    return '#4a9adc'
                                }
                                return '#c5d8f0'
                            },
                            borderColor: '#1890ff',
                            borderWidth: 2,
                            shadowColor: 'rgba(24, 144, 255, 0.4)',
                            shadowBlur: 15
                        },
                        label: {
                            color: '#1a365d',
                            fontWeight: 'bold',
                            fontSize: 14
                        }
                    },
                    select: {
                        itemStyle: {
                            areaColor: '#3ba0ff',
                            borderColor: '#096dd9',
                            borderWidth: 3
                        }
                    },
                    label: {
                        show: true,
                        color: '#333',
                        fontSize: 12
                    },
                    animation: true,
                    animationDurationUpdate: 800,
                    animationEasingUpdate: 'cubicOut'
                }],
                tooltip: {
                        trigger: 'item',
                        backgroundColor: 'rgba(255, 255, 255, 0.98)',
                        borderColor: '#e8e8e8',
                        borderWidth: 1,
                        padding: [14, 18],
                        textStyle: {
                            color: '#333',
                            fontSize: 14
                        },
                        extraCssText: 'box-shadow: 0 6px 16px rgba(26, 54, 93, 0.12); border-radius: 12px;',
                        formatter: (params) => {
                            if (params.dataType === 'feature' || params.data?.properties?.name || params.name) {
                                const name = params.data?.properties?.name || params.name || params.data?.name
                                const count = this.getCustomerCountByCityName(name)
                                return `<div style="font-weight:600;margin-bottom:8px;font-size:16px;color:#1a365d">${name}</div>
                                        <div style="font-size:14px;color:#718096;margin-bottom:6px">客户数量：<span style="color:#3ba0ff;font-weight:bold;font-size:18px">${count}</span> 个</div>
                                        <div style="font-size: 14px;color:#a0aec0;margin-top:8px;padding-top:8px;border-top:1px solid #e2e8f0">点击查看详情</div>`
                            }
                            return ''
                        }
                    }
            }
        },
        async loadProvinceMap() {
            try {
                this.provinceData = await this.loadProvinceData()
                
                if (!this.provinceData) {
                    Message.error('加载地图数据失败，请刷新页面重试')
                    this.isMapLoading = false
                    return
                }
                
                echarts.registerMap('jiangxi', this.provinceData)
                
                const option = this.createProvinceOption()
                this.$nextTick(() => {
                    if (this.chart && !this.chart.isDisposed()) {
                        this.chart.setOption(option, true)
                    }
                })
                
            } catch (error) {
                console.error('加载省级地图失败:', error)
            } finally {
                this.isMapLoading = false
            }
        },
        calculateCenter(geoData) {
            if (!geoData || !geoData.features || geoData.features.length === 0) {
                return this.getCityCenter(this.currentCity) || [115.9, 27.6]
            }
            
            // 使用多边形重心算法，而非简单的边界框中点
            let totalWeight = 0
            let centerLng = 0
            let centerLat = 0
            
            geoData.features.forEach(feature => {
                if (!feature.geometry || !feature.geometry.coordinates) return
                
                const coords = feature.geometry.coordinates
                
                if (feature.geometry.type === 'Polygon' || feature.geometry.type === 'MultiPolygon') {
                    const polygons = feature.geometry.type === 'MultiPolygon' ? coords : [coords]
                    
                    polygons.forEach(polygon => {
                        const outerRing = polygon[0]
                        if (!outerRing || outerRing.length < 3) return
                        
                        let area = 0
                        let cx = 0, cy = 0
                        
                        for (let i = 0; i < outerRing.length - 1; i++) {
                            const [x1, y1] = outerRing[i]
                            const [x2, y2] = outerRing[i + 1]
                            const cross = x1 * y2 - x2 * y1
                            area += cross
                            cx += (x1 + x2) * cross
                            cy += (y1 + y2) * cross
                        }
                        
                        area /= 2
                        if (Math.abs(area) > 0.0001) {
                            cx /= (6 * area)
                            cy /= (6 * area)
                            centerLng += cx * Math.abs(area)
                            centerLat += cy * Math.abs(area)
                            totalWeight += Math.abs(area)
                        }
                    })
                }
            })
            
            if (totalWeight > 0) {
                return [centerLng / totalWeight, centerLat / totalWeight]
            }
            
            // Fallback to bounding box center
            let minLng = Infinity, maxLng = -Infinity
            let minLat = Infinity, maxLat = -Infinity
            
            const processCoords = (coords) => {
                if (typeof coords[0] === 'number') {
                    minLng = Math.min(minLng, coords[0])
                    maxLng = Math.max(maxLng, coords[0])
                    minLat = Math.min(minLat, coords[1])
                    maxLat = Math.max(maxLat, coords[1])
                } else {
                    coords.forEach(coord => processCoords(coord))
                }
            }
            
            geoData.features.forEach(feature => {
                if (feature.geometry && feature.geometry.coordinates) {
                    processCoords(feature.geometry.coordinates)
                }
            })
            
            return [
                (minLng + maxLng) / 2,
                (minLat + maxLat) / 2
            ]
        },
        createCityOption(cityName, center, customers, focusCustomer) {
            const markers = (customers || []).map(customer => ({
                name: customer.custName || customer.customer_name || '未知',
                value: [customer.longitude, customer.latitude],
                customer: customer
            }))
            
            const mapCenter = focusCustomer && focusCustomer.longitude && focusCustomer.latitude 
                ? [focusCustomer.longitude, focusCustomer.latitude] 
                : center
            
            console.log(`🗺️ 正在创建城市[${cityName}]地图配置`)
            console.log(`📍 中心点: [${mapCenter}]`)
            console.log(`📍 标记点数量: ${markers.length}`)
            
            const isTech = this.mapTheme === 'tech'
            
            const categoryColors = {
                '政府': '#1890ff',
                '教育': '#52c41a',
                '企业': '#faad14',
                '央国企': '#722ed1',
                '金融': '#eb2f96',
                '医疗': '#13c2c2',
                '其他': '#fa8c16'
            }
            
            return {
                backgroundColor: isTech ? '#0a1929' : '#ffffff',
                geo: {
                    map: cityName,
                    roam: true,
                    zoom: 1.8,
                    center: mapCenter,
                    scaleLimit: {
                        min: 1,
                        max: 5
                    },
                    itemStyle: {
                        areaColor: '#e8f4fc',
                        borderColor: '#91d5ff',
                        borderWidth: 1.5
                    },
                    emphasis: {
                        itemStyle: {
                            areaColor: '#e8f4fc',
                            borderColor: '#91d5ff'
                        },
                        label: {
                            color: '#1a365d',
                            fontWeight: 'bold',
                            fontSize: 18
                        }
                    },
                    select:{
                        itemStyle: {
                            areaColor: '#e8f4fc',
                            borderColor: '#096dd9',
                            borderWidth:2,
                            shadowColor: 'rgba(24, 144, 255, 0.2)',

                        },
                    },
                    label: {
                        show: true,
                        color: '#666',
                        fontSize: 16,
                        fontWeight: 'normal'
                    }
                },
                series: [
                    {
                        type: 'map',
                        map: cityName,
                        geoIndex: 0,
                        aspectScale: 0.75,
                        showLegendSymbol: false,
                        selectedMode: 'single',
                        itemStyle: {
                            areaColor: isTech ? 'rgba(0, 100, 200, 0.15)' : '#e8f4fc'
                        },
                        emphasis: {
                            itemStyle: {
                                areaColor: isTech ? 'rgba(0, 100, 200, 0.15)' : '#e8f4fc',
                                borderColor: isTech ? '#00ff88' : '#1890ff',
                                borderWidth: 2,
                                shadowColor: 'rgba(24, 144, 255, 0.5)',
                                shadowBlur: 15
                            },
                            label: {
                                color: isTech ? '#00ff88' : '#1a365d',
                                fontWeight: 'bold',
                                fontSize: 12
                            }
                        },
                        select: {
                            itemStyle: {
                                areaColor: isTech ? 'rgba(0, 100, 200, 0.15)' : '#e8f4fc',
                                borderColor: isTech ? '#00d4ff' : '#096dd9',
                                borderWidth: 3
                            }
                        },
                        animation: true,
                        animationDurationUpdate: 800,
                        animationEasingUpdate: 'cubicOut'
                    },
                    {
                        name: '客户标记',
                        type: 'effectScatter',
                        coordinateSystem: 'geo',
                        data: markers.filter(m => m.value[0] && m.value[1] && !isNaN(m.value[0]) && !isNaN(m.value[1])),
                        symbolSize: isTech ? 14 : 12,
                        showEffectOn: 'render',
                        rippleEffect: {
                            brushType: 'stroke',
                            scale: isTech ? 4 : 3,
                            period: isTech ? 2 : 3
                        },
                        itemStyle: {
                            color: (params) => {
                                const industry = params.data?.customer?.industryName || params.data?.customer?.customer_category || ''
                                return this.getIndustryColor(industry)
                            },
                            shadowBlur: isTech ? 15 : 10,
                            shadowColor: (params) => {
                                const industry = params.data?.customer?.industryName || params.data?.customer?.customer_category || ''
                                return this.getIndustryColor(industry)
                            }
                        },
                        label: {
                            show: true,
                            position: 'top',
                            distance: 8,
                            formatter: '{b}',
                            fontSize: isTech ? 11 : 12,
                            color: isTech ? '#00ff88' : '#1a365d',
                            backgroundColor: isTech ? 'rgba(10, 25, 41, 0.9)' : 'rgba(255, 255, 255, 0.9)',
                            borderColor: isTech ? '#00d4ff' : '#1890ff',
                            borderWidth: 1,
                            borderRadius: 4,
                            padding: [4, 8],
                            shadowBlur: isTech ? 5 : 3,
                            shadowColor: isTech ? 'rgba(0, 212, 255, 0.3)' : 'rgba(24, 144, 255, 0.15)'
                        },
                        zlevel: 100
                    }
                ],
                legend: {
                    show: false
                }
            }
        },
        async loadCityMap(cityName) {
            this.isMapLoading = true
            
            try {
                console.log(`正在加载城市地图: ${cityName}`)
                
                // 检查缓存，忽略null/空数据
                if (this.cityDataCache[cityName] && this.cityDataCache[cityName].features && this.cityDataCache[cityName].features.length > 0) {
                    console.log(`从缓存加载${cityName}地图`)
                } else {
                    const cityData = await this.loadCityData(cityName)
                    console.log(`城市数据加载结果:`, cityData)
                    
                    if (cityData && cityData.features && cityData.features.length > 0) {
                        this.cityDataCache[cityName] = cityData
                    } else {
                        // 所有数据源都失败，生成简化的城市轮廓
                        console.warn(`所有数据源都失败，生成简化轮廓: ${cityName}`)
                        this.cityDataCache[cityName] = this.generateFallbackCityGeoData(cityName)
                    }
                }
                
                const cityGeoData = this.cityDataCache[cityName]
                
                echarts.registerMap(cityName, cityGeoData)
                
                const center = this.calculateCenter(cityGeoData)
                this.cityCenterCache[cityName] = center
                
                const customers = await this.loadCityCustomers(cityName)
                this.cityCustomersCache[cityName] = customers
                const option = this.createCityOption(cityName, center, [])
                this.chart.setOption(option, true)
                
                this.currentLevel = 'city'
                this.currentCity = cityName
                
            } catch (error) {
                console.error(`加载${cityName}地图失败:`, error)
                Message.error(`加载${cityName}地图失败：${error.message}`)
                this.currentLevel = 'province'
                this.currentCity = null
                const option = this.createProvinceOption()
                this.chart.setOption(option, true)
            } finally {
                this.isMapLoading = false
            }
        },
        generateFallbackCityGeoData(cityName) {
            // 使用江西省内城市的大致形状
            const cityBounds = {
                '赣州市': {
                    center: [114.9355, 25.8453],
                    bounds: { minLng: 113.9, maxLng: 116.1, minLat: 24.5, maxLat: 27.2 }
                },
                '南昌市': {
                    center: [115.8921, 28.6877],
                    bounds: { minLng: 115.5, maxLng: 116.4, minLat: 28.2, maxLat: 29.3 }
                },
                '九江市': {
                    center: [115.9676, 29.7057],
                    bounds: { minLng: 115.3, maxLng: 116.6, minLat: 29.1, maxLat: 30.3 }
                },
                '景德镇市': {
                    center: [117.1784, 29.2687],
                    bounds: { minLng: 116.8, maxLng: 117.7, minLat: 28.8, maxLat: 29.7 }
                },
                '萍乡市': {
                    center: [113.8545, 27.6228],
                    bounds: { minLng: 113.5, maxLng: 114.3, minLat: 27.2, maxLat: 28.1 }
                },
                '新余市': {
                    center: [114.9171, 27.8179],
                    bounds: { minLng: 114.5, maxLng: 115.4, minLat: 27.4, maxLat: 28.2 }
                },
                '鹰潭市': {
                    center: [117.0694, 28.2607],
                    bounds: { minLng: 116.7, maxLng: 117.8, minLat: 27.8, maxLat: 28.7 }
                },
                '吉安市': {
                    center: [114.9793, 27.1095],
                    bounds: { minLng: 114.2, maxLng: 115.9, minLat: 26.3, maxLat: 27.9 }
                },
                '宜春市': {
                    center: [114.4156, 27.8134],
                    bounds: { minLng: 113.7, maxLng: 115.3, minLat: 27.2, maxLat: 28.8 }
                },
                '抚州市': {
                    center: [116.3584, 27.9492],
                    bounds: { minLng: 115.8, maxLng: 117.3, minLat: 26.6, maxLat: 28.3 }
                },
                '上饶市': {
                    center: [117.9435, 28.4557],
                    bounds: { minLng: 117.2, maxLng: 118.8, minLat: 27.8, maxLat: 29.5 }
                }
            }
            
            const city = cityBounds[cityName] || {
                center: [115.9, 27.6],
                bounds: { minLng: 115.4, maxLng: 116.4, minLat: 27.2, maxLat: 28.2 }
            }
            
            const { minLng, maxLng, minLat, maxLat } = city.bounds
            
            // 生成六边形近似轮廓
            const coords = [
                [minLng, minLat],
                [(minLng + maxLng) / 2, minLat - (maxLat - minLat) * 0.1],
                [maxLng, minLat],
                [maxLng + (maxLng - minLng) * 0.05, (minLat + maxLat) / 2],
                [maxLng, maxLat],
                [(minLng + maxLng) / 2, maxLat + (maxLat - minLat) * 0.1],
                [minLng, maxLat],
                [minLng - (maxLng - minLng) * 0.05, (minLat + maxLat) / 2],
                [minLng, minLat]
            ]
            
            return {
                type: 'FeatureCollection',
                features: [{
                    type: 'Feature',
                    properties: { name: cityName },
                    geometry: {
                        type: 'Polygon',
                        coordinates: [coords]
                    }
                }]
            }
        },
        backToProvince() {
            this.isMapLoading = true
            
            const option = this.createProvinceOption()
            this.chart.setOption(option, true)
            
            this.currentLevel = 'province'
            this.currentCity = null
            
            setTimeout(() => {
                this.isMapLoading = false
            }, 100)
        },
        setupEventListeners() {
            this.chart.on('click', async (params) => {
                if (this.isSelectingLocation && params.coordinate) {
                    this.handleMapClick(params.coordinate)
                    return
                }
                
                if (this.currentLevel !== 'province') {
                    if (params.data && params.data.customer) {
                        this.showCustomerInfo(params.data.customer)
                    }
                    return
                }
                
                if (params.name && this.cityNames.includes(params.name)) {
                    this.isCustomerMarkersVisible = false
                    await this.loadCityMap(params.name)
                }
            })
        },
        toggleLocationSelection() {
            this.isSelectingLocation = !this.isSelectingLocation
            if (this.isSelectingLocation) {
                Message.info('请在地图上点击选择位置')
            } else {
                this.selectedLocation = null
            }
        },
        handleLocationSearch() {
            if (!this.locationSearchKeyword || this.locationSearchKeyword.length < 2) {
                this.locationSuggestions = []
                return
            }
            this.locationSuggestions = [
                { name: this.locationSearchKeyword + ' (地点1)', address: '江西省南昌市', lng: 115.89, lat: 28.68 },
                { name: this.locationSearchKeyword + ' (地点2)', address: '江西省九江市', lng: 115.97, lat: 29.71 }
            ]
        },
        selectLocation(location) {
            this.selectedLocation = location
            this.isSelectingLocation = false
            Message.success('已选择位置: ' + location.name)
        },
        handleMapClick(coordinates) {
            if (this.isSelectingLocation && coordinates) {
                this.selectedLocation = {
                    name: '地图选点',
                    address: `经度: ${coordinates[0].toFixed(6)}, 纬度: ${coordinates[1].toFixed(6)}`,
                    lng: coordinates[0],
                    lat: coordinates[1]
                }
                this.isSelectingLocation = false
                Message.success('位置已选中')
            }
        },
        toggleCustomerMarkers() {
            if (!this.currentCity || !this.chart) return
            
            this.isCustomerMarkersVisible = !this.isCustomerMarkersVisible
            
            const customers = this.cityCustomersCache[this.currentCity] || []
            const option = this.createCityOption(this.currentCity, this.cityCenterCache[this.currentCity], this.isCustomerMarkersVisible ? customers : [], null)
            this.chart.setOption(option, true)
            
            if (this.isCustomerMarkersVisible && this.currentCustomers.length > 0) {
                this.$nextTick(() => {
                    const listPanel = document.querySelector('.customer-list-panel')
                    if (listPanel) {
                        listPanel.style.display = 'flex'
                    }
                })
            }
        },
    }
}
</script>

<style scoped lang="scss">
.cust-map-container {
    padding: 16px 24px;
    background: 
        radial-gradient(circle at 20% 80%, rgba(24, 144, 255, 0.03) 0%, transparent 50%),
        radial-gradient(circle at 80% 20%, rgba(114, 46, 209, 0.03) 0%, transparent 50%),
        linear-gradient(135deg, #f8fafc 0%, #edf2f7 50%, #f0f4f8 100%);
    height: calc(100vh - 64px);
    position: relative;
    overflow: hidden;
}

.cust-map-container::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: 
        linear-gradient(rgba(24, 144, 255, 0.02) 1px, transparent 1px),
        linear-gradient(90deg, rgba(24, 144, 255, 0.02) 1px, transparent 1px);
    background-size: 40px 40px;
    pointer-events: none;
}

.cust-map-container::after {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(ellipse at center, rgba(24, 144, 255, 0.01) 0%, transparent 70%);
    pointer-events: none;
}

.map-header {
    margin-bottom: 24px;
    position: relative;
    z-index: 1;
}

.map-header h1 {
    margin: 0 0 4px 0;
    font-size: 28px;
    font-weight: 600;
    color: #1a365d;
    text-shadow: 0 1px 2px rgba(26, 54, 93, 0.1);
}

.map-header .map-desc {
    margin: 0;
    font-size: 14px;
    color: #718096;
}

.map-card {
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.95) 100%);
    backdrop-filter: blur(20px);
    border-radius: 16px;
    box-shadow: 
        0 8px 32px rgba(26, 54, 93, 0.08),
        0 0 0 1px rgba(24, 144, 255, 0.1),
        inset 0 1px 0 rgba(255, 255, 255, 0.5);
    overflow: hidden;
    position: relative;
    display: flex;
    flex-direction: column;
}

.card-header {
    padding: 16px 24px;
    border-bottom: 1px solid rgba(226, 232, 240, 0.8);
    background: linear-gradient(90deg, rgba(248, 250, 252, 0.8) 0%, rgba(255, 255, 255, 0.9) 100%);
    position: relative;
}

.card-header::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, 
        transparent 0%, 
        rgba(24, 144, 255, 0.3) 20%, 
        rgba(24, 144, 255, 0.3) 80%, 
        transparent 100%
    );
}

.chart-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
    color: #1a365d;
    position: relative;
}

.chart-title i {
    font-size: 18px;
    color: #1890ff;
    filter: drop-shadow(0 0 4px rgba(24, 144, 255, 0.4));
}

.breadcrumb-nav {
    display: flex;
    align-items: center;
}

.breadcrumb-link {
    cursor: pointer;
    color: #3182ce;
    transition: all 0.3s ease;
    position: relative;
    padding: 2px 8px;
    border-radius: 4px;
}

.breadcrumb-link:hover {
    color: #1e40af;
    background: rgba(24, 144, 255, 0.08);
    text-decoration: none;
}

.breadcrumb-separator {
    color: #a0aec0;
    margin: 0 8px;
}

.ml-auto {
    margin-left: auto;
}

.ml-8 {
    margin-left: 8px;
}

.industry-tag-gov { 
    background: linear-gradient(135deg, #e6f7ff 0%, #bae7ff 100%) !important; 
    border-color: #1890ff !important; 
    color: #1890ff !important; 
    font-weight: 500;
    box-shadow: 0 2px 8px rgba(24, 144, 255, 0.2);
}
.industry-tag-gov:hover {
    box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3), 0 0 8px rgba(24, 144, 255, 0.2);
}
.industry-tag-enterprise { 
    background: linear-gradient(135deg, #fff7e6 0%, #ffe58f 100%) !important; 
    border-color: #fa8c16 !important; 
    color: #d97706 !important; 
    font-weight: 500;
    box-shadow: 0 2px 8px rgba(250, 140, 22, 0.2);
}
.industry-tag-enterprise:hover {
    box-shadow: 0 4px 12px rgba(250, 140, 22, 0.3), 0 0 8px rgba(250, 140, 22, 0.2);
}
.industry-tag-education { 
    background: linear-gradient(135deg, #f6ffed 0%, #b7eb8f 100%) !important; 
    border-color: #52c41a !important; 
    color: #389e0d !important; 
    font-weight: 500;
    box-shadow: 0 2px 8px rgba(82, 196, 26, 0.2);
}
.industry-tag-education:hover {
    box-shadow: 0 4px 12px rgba(82, 196, 26, 0.3), 0 0 8px rgba(82, 196, 26, 0.2);
}
.industry-tag-finance { 
    background: linear-gradient(135deg, #fff0f6 0%, #ffadd2 100%) !important; 
    border-color: #eb2f96 !important; 
    color: #c41e7e !important; 
    font-weight: 500;
    box-shadow: 0 2px 8px rgba(235, 47, 150, 0.2);
}
.industry-tag-finance:hover {
    box-shadow: 0 4px 12px rgba(235, 47, 150, 0.3), 0 0 8px rgba(235, 47, 150, 0.2);
}
.industry-tag-medical { 
    background: linear-gradient(135deg, #e6fffb 0%, #91e5e5 100%) !important; 
    border-color: #13c2c2 !important; 
    color: #08979c !important; 
    font-weight: 500;
    box-shadow: 0 2px 8px rgba(19, 194, 194, 0.2);
}
.industry-tag-medical:hover {
    box-shadow: 0 4px 12px rgba(19, 194, 194, 0.3), 0 0 8px rgba(19, 194, 194, 0.2);
}
.industry-tag-state { 
    background: linear-gradient(135deg, #f9f0ff 0%, #d3adf7 100%) !important; 
    border-color: #722ed1 !important; 
    color: #531dab !important; 
    font-weight: 500;
    box-shadow: 0 2px 8px rgba(114, 46, 209, 0.2);
}
.industry-tag-state:hover {
    box-shadow: 0 4px 12px rgba(114, 46, 209, 0.3), 0 0 8px rgba(114, 46, 209, 0.2);
}
.industry-tag-personal { 
    background: linear-gradient(135deg, #f9f0ff 0%, #d3adf7 100%) !important; 
    border-color: #722ed1 !important; 
    color: #531dab !important; 
    font-weight: 500;
    box-shadow: 0 2px 8px rgba(114, 46, 209, 0.2);
}
.industry-tag-personal:hover {
    box-shadow: 0 4px 12px rgba(114, 46, 209, 0.3), 0 0 8px rgba(114, 46, 209, 0.2);
}
.industry-tag-partner { 
    background: linear-gradient(135deg, #fff7e6 0%, #ffe58f 100%) !important; 
    border-color: #fa8c16 !important; 
    color: #d97706 !important; 
    font-weight: 500;
    box-shadow: 0 2px 8px rgba(250, 140, 22, 0.2);
}
.industry-tag-partner:hover {
    box-shadow: 0 4px 12px rgba(250, 140, 22, 0.3), 0 0 8px rgba(250, 140, 22, 0.2);
}
.industry-tag-other { 
    background: linear-gradient(135deg, #f7f7f7 0%, #e8e8e8 100%) !important; 
    border-color: #8c8c8c !important; 
    color: #666 !important; 
    font-weight: 500;
    box-shadow: 0 2px 8px rgba(140, 140, 140, 0.2);
}
.industry-tag-other:hover {
    box-shadow: 0 4px 12px rgba(140, 140, 140, 0.3), 0 0 8px rgba(140, 140, 140, 0.2);
}

.map-container {
    width: 100%;
    height: calc(100vh - 200px);
    min-height: 500px;
    position: relative;
}

.map-card.fullscreen-mode .map-container {
    height: calc(100vh - 60px) !important;
    min-height: auto !important;
    flex: 1 !important;
}

.map-container.has-detail-panel {
    padding-right: 420px;
}

.map-container.has-detail-panel .stats-overlay {
    z-index: 999;
}

.customer-detail-panel {
    position: absolute;
    top: 60px;
    right: 0;
    width: 420px;
    height: calc(100% - 100px);
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, rgba(255, 255, 255, 0.95) 100%);
    backdrop-filter: blur(20px);
    border-left: 1px solid rgba(24, 144, 255, 0.15);
    box-shadow: 
        -8px 0 32px rgba(26, 54, 93, 0.1),
        inset 1px 0 0 rgba(255, 255, 255, 0.5);
    z-index: 1001;
    display: flex;
    flex-direction: column;
    border-radius: 16px 0 0 16px;
    overflow: hidden;
}

.customer-detail-panel::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, 
        #1890ff 0%, 
        #722ed1 50%, 
        #1890ff 100%
    );
    background-size: 200% 100%;
    animation: shimmer 3s ease-in-out infinite;
}

@keyframes shimmer {
    0%, 100% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
}

.customer-detail-panel.fullscreen-panel {
    position: fixed;
    top: 60;
    right: 0;
    width: 420px;
    height: 100vh;
    z-index: 10001;
}

.stats-overlay {
    position: absolute;
    bottom: 80px;
    left: 24px;
    z-index: 1000;
    display: flex;
    flex-direction: row;
    gap: 12px;
    background: rgba(255, 255, 255, 0.92);
    backdrop-filter: blur(16px);
    padding: 16px;
    border-radius: 16px;
    box-shadow: 
        0 8px 32px rgba(26, 54, 93, 0.1),
        0 0 0 1px rgba(24, 144, 255, 0.08),
        inset 0 1px 0 rgba(255, 255, 255, 0.8);
    border: 1px solid rgba(24, 144, 255, 0.1);
}

.fullscreen-stats-overlay {
    bottom: 40px;
    left: 40px;
    padding: 20px;
}

.stat-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 16px;
    border-radius: 12px;
    transition: all 0.3s ease;
    min-width: 120px;
    border: 1px solid transparent;
}

.stat-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(26, 54, 93, 0.15);
    border-color: currentColor;
}

.stat-item-primary {
    background: linear-gradient(135deg, rgba(230, 247, 255, 0.9) 0%, rgba(186, 231, 255, 0.8) 100%);
    border-left: 3px solid #1890ff;
    box-shadow: 
        0 2px 8px rgba(24, 144, 255, 0.15),
        inset 0 1px 0 rgba(255, 255, 255, 0.5);
    position: relative;
    overflow: hidden;
}

.stat-item-primary::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(ellipse at center, rgba(24, 144, 255, 0.1) 0%, transparent 70%);
    animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
    0%, 100% { transform: scale(0.8); opacity: 0.5; }
    50% { transform: scale(1); opacity: 0.8; }
}

.stat-item-success {
    background: linear-gradient(135deg, rgba(246, 255, 237, 0.9) 0%, rgba(183, 235, 175, 0.8) 100%);
    border-left: 3px solid #52c41a;
    box-shadow: 
        0 2px 8px rgba(82, 196, 26, 0.15),
        inset 0 1px 0 rgba(255, 255, 255, 0.5);
}

.stat-item-warning {
    background: linear-gradient(135deg, rgba(255, 251, 230, 0.9) 0%, rgba(255, 229, 143, 0.8) 100%);
    border-left: 3px solid #faad14;
    box-shadow: 
        0 2px 8px rgba(250, 173, 20, 0.15),
        inset 0 1px 0 rgba(255, 255, 255, 0.5);
    cursor: pointer;
    transition: all 0.3s ease;
}

.stat-item-warning:hover {
    transform: translateY(-2px);
    box-shadow: 
        0 6px 16px rgba(250, 173, 20, 0.25),
        inset 0 1px 0 rgba(255, 255, 255, 0.5);
}

.stat-item-purple {
    background: linear-gradient(135deg, rgba(249, 240, 255, 0.9) 0%, rgba(211, 173, 247, 0.8) 100%);
    border-left: 3px solid #722ed1;
    box-shadow: 
        0 2px 8px rgba(114, 46, 209, 0.15),
        inset 0 1px 0 rgba(255, 255, 255, 0.5);
}

.stat-icon {
    font-size: 20px;
    margin-right: 4px;
}

.stat-item-primary .stat-icon {
    color: #1890ff;
}

.stat-item-success .stat-icon {
    color: #52c41a;
}

.stat-item-warning .stat-icon {
    color: #faad14;
}

.stat-item-purple .stat-icon {
    color: #722ed1;
}

.stat-content {
    display: flex;
    flex-direction: column;
}

.stat-label {
    font-size: $font-size-base;
    color: #718096;
    margin-bottom: 2px;
}

.stat-value {
    font-size: 20px;
    font-weight: 600;
    color: #1a365d;
}

.stat-item-primary .stat-value {
    color: #1890ff;
}

.stat-item-success .stat-value {
    color: #52c41a;
}

.stat-item-warning .stat-value {
    color: #faad14;
}

.stat-item-purple .stat-value {
    color: #722ed1;
}

.stat-item-primary {
    background: linear-gradient(135deg, #e6f7ff 0%, #bae7ff 100%);
    border-left: 3px solid #1890ff;
}

.stat-item-success {
    background: linear-gradient(135deg, #f6ffed 0%, #b7eb8f 100%);
    border-left: 3px solid #52c41a;
}

.stat-item-warning {
    background: linear-gradient(135deg, #fffbe6 0%, #ffe58f 100%);
    border-left: 3px solid #faad14;
    cursor: pointer;
}

.stat-item-purple {
    background: linear-gradient(135deg, #f9f0ff 0%, #d3adf7 100%);
    border-left: 3px solid #722ed1;
}

.stat-icon {
    font-size: 20px;
    margin-right: 4px;
}

.stat-item-primary .stat-icon {
    color: #1890ff;
}

.stat-item-success .stat-icon {
    color: #52c41a;
}

.stat-item-warning .stat-icon {
    color: #faad14;
}

.stat-item-purple .stat-icon {
    color: #722ed1;
}

.stat-content {
    display: flex;
    flex-direction: column;
}

.stat-label {
    font-size: $font-size-base;
    color: #8c8c8c;
    margin-bottom: 2px;
}

.stat-value {
    font-size: 20px;
    font-weight: 600;
}

.stat-item-primary .stat-value {
    color: #1890ff;
}

.stat-item-success .stat-value {
    color: #52c41a;
}

.stat-item-warning .stat-value {
    color: #faad14;
}

.stat-item-purple .stat-value {
    color: #722ed1;
}

#loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.98);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 999;
    transition: opacity 0.5s ease;
}

#loading-overlay.hidden {
    opacity: 0;
    pointer-events: none;
}

.spinner {
    width: 50px;
    height: 50px;
    border: 4px solid #e8f4fc;
    border-top: 4px solid #1890ff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.loading-text {
    margin-top: 20px;
    font-size: 14px;
    color: #666;
    letter-spacing: 1px;
}

.customer-detail-panel {
    position: absolute;
    top: 60px;
    right: 0;
    width: 420px;
    height: calc(100% - 100px);
    background: #fff;
    border-left: 1px solid #e8e8e8;
    box-shadow: -4px 0 16px rgba(0, 0, 0, 0.12);
    z-index: 1001;
    display: flex;
    flex-direction: column;
    transition: all 0.3s ease;
}

.customer-detail-panel.fullscreen-panel {
    position: fixed;
    top: 60;
    right: 0;
    width: 420px;
    height: 100vh;
    z-index: 10001;
}

.customer-detail-panel .panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    border-bottom: 1px solid #f0f0f0;
    background: #fafafa;
    flex-shrink: 0;
}

.customer-detail-panel .panel-header h3 {
    margin: 0;
    color: #1890ff;
    font-size: 16px;
    font-weight: 600;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-right: 12px;
}

.customer-detail-panel .close-btn {
    cursor: pointer;
    font-size: 20px;
    color: #999;
    transition: color 0.3s;
    flex-shrink: 0;
}

.customer-detail-panel .close-btn:hover {
    color: #ff4d4f;
}

.customer-detail-panel .panel-body {
    flex: 1;
    overflow-y: auto;
    padding: 16px 20px;
}

.customer-detail-panel .detail-tag {
    margin-bottom: 8px;
}

.slide-right-enter-active {
    transition: transform 0.35s ease;
}

.slide-right-leave-active {
    transition: transform 0.25s ease;
}

.slide-right-enter,
.slide-right-leave-to {
    transform: translateX(420px);
}

.fullscreen-btn-icon {
    cursor: pointer;
    font-size: 18px;
    color: #666;
    transition: color 0.3s;
}

.icon-exit-fullscreen::before {
    content: '⬚';
    font-size: 18px;
    line-height: 1;
    display: inline-block;
}

.fullscreen-btn-icon:hover {
    color: #1890ff;
}

.customer-list-panel {
    position: absolute;
    top: 80px;
    left: 10px;
    width: 280px;
    max-height: calc(100% - 20px);
    background: rgba(255, 255, 255, 0.98);
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    display: flex !important;
    flex-direction: column;
    z-index: 2000;
    overflow: hidden;
}

.city-stats-panel {
    position: absolute;
    bottom: 24px;
    left: 24px;
    width: 180px;
    background: rgba(255, 255, 255, 0.98);
    border-radius: 10px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
    z-index: 2000;
    overflow: hidden;
    display: block !important;
}

.city-stats-panel-header {
    padding: 12px 16px;
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    border-bottom: 1px solid #f0f0f0;
    background: rgba(255, 255, 255, 0.98);
}

.city-stats-panel-list {
    max-height: 360px;
    overflow-y: auto;
    padding: 4px 0;
}

.city-stats-panel-item {
    display: flex;
    align-items: center;
    padding: 8px 16px;
    font-size: 13px;
    transition: background-color 0.2s;
}

.city-stats-panel-item.has-count {
    background: rgba(24, 144, 255, 0.06);
}

.city-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 8px;
    flex-shrink: 0;
    box-shadow: 0 0 4px rgba(24, 144, 255, 0.3);
}

.city-overlay-name {
    flex: 1;
    color: #606266;
}

.city-stats-panel-item.has-count .city-overlay-name {
    color: #303133;
    font-weight: 500;
}

.city-overlay-count {
    font-weight: 600;
    font-size: 14px;
    min-width: 30px;
    text-align: right;
}

.customer-list-header {
    padding: 12px 16px;
    font-weight: 600;
    color: #303133;
    border-bottom: 1px solid #e8e8e8;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.customer-count {
    background: #1890ff;
    color: #fff;
    font-size: $font-size-base;
    padding: 2px 8px;
    border-radius: 10px;
}

.customer-list-search {
    padding: 10px 12px;
    border-bottom: 1px solid #f0f0f0;
}

.customer-list-body {
    flex: 1;
    overflow-y: auto;
    max-height: 400px;
}

.customer-list-item {
    padding: 10px 14px;
    cursor: pointer;
    border-bottom: 1px solid #f5f5f5;
    transition: background-color 0.2s;
}

.customer-list-item:hover {
    background: #f0f9ff;
}

.customer-list-item.active {
    background: #e6f7ff;
    border-left: 3px solid #1890ff;
}

.customer-tag {
    border-width: 1px !important;
    border-style: solid !important;
    font-weight: 500 !important;
}

.customer-item-name {
    font-size: 13px;
    font-weight: 500;
    color: #303133;
    margin-bottom: 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.customer-item-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: $font-size-md;
}

.customer-item-city {
    color: #909399;
}

.customer-list-empty {
    padding: 30px 14px;
    text-align: center;
    color: #909399;
    font-size: 13px;
}
</style>

<style>
body {
    overflow: hidden !important;
}

html {
    overflow: hidden !important;
}
</style>

<style scoped>
.map-card.fullscreen-mode {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100vw !important;
    height: 100vh !important;
    z-index: 9998 !important;
    border-radius: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
}

.map-card.fullscreen-mode .map-container {
    width: 100% !important;
    height: calc(100vh - 60px) !important;
    min-height: auto !important;
}

.map-card.fullscreen-mode .map-container canvas {
    width: 100% !important;
    height: 100% !important;
}
